/**
 * Example action that shows a notification
 * This action can be triggered with: window.addEventListener('arc:action:showNotification')
 */

export const runShowNotification = async (data = {}) => {
    try {
        const {
            message = 'Hello from the event system!',
            type = 'info',
            duration = 3000
        } = data;

        console.log(`Notification [${type}]: ${message}`);

        // Create a simple notification element
        const notification = document.createElement('div');
        notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background: ${type === 'error' ? '#dc3545' : type === 'success' ? '#28a745' : '#17a2b8'};
            color: white;
            padding: 15px 20px;
            border-radius: 5px;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            z-index: 10000;
            max-width: 300px;
            font-family: Arial, sans-serif;
            font-size: 14px;
            transform: translateX(100%);
            transition: transform 0.3s ease;
        `;
        
        notification.textContent = message;
        document.body.appendChild(notification);

        // Animate in
        setTimeout(() => {
            notification.style.transform = 'translateX(0)';
        }, 10);

        // Remove after duration
        setTimeout(() => {
            notification.style.transform = 'translateX(100%)';
            setTimeout(() => {
                if (notification.parentNode) {
                    notification.parentNode.removeChild(notification);
                }
            }, 300);
        }, duration);

        return {
            success: true,
            message: 'Notification displayed',
            data: { message, type, duration }
        };

    } catch (error) {
        console.error('Error showing notification:', error);
        return {
            success: false,
            error: error.message
        };
    }
};

export default runShowNotification;
